import React from 'react';

import { Box, Text, StyledOcticon } from '@primer/components'
import { IssueOpened } from '@primer/octicons-react'


export default function(props) {
  return (
    <Box as="span" style={{verticalAlign: 'middle'}} className="f4">
      <StyledOcticon icon={IssueOpened} size={20} className="ml-1 mr-1 p1" />
      <Text>{props.error}</Text>
    </Box>
  )
}
